module.exports = __webpack_public_path__ + "img/honor2.068de4fa.jpg";